module.exports = __webpack_public_path__ + "eb2f59f70ec4a1bd7b7b9f3c841d5a4e.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/data/assets/audio/notification.mp3
// module id = 3909
// module chunks = 13